import getDataSelector from 'core/utils/getDataSelector'
import { createSharedSelector } from 'core/utils/selectorHelpers'
import DataKeys from 'k8s/DataKeys'

export const kaapiClusterAddonsSelector = createSharedSelector(
  getDataSelector<DataKeys.KaapiClusterAddons>(DataKeys.KaapiClusterAddons),
  (kaapiClusterAddons) => {
    return kaapiClusterAddons
  },
)
